import React, { useState, useRef, useCallback } from "react";
import { useWindowSize } from "../../hooks/useWindowSize";
import { useAuth } from "../../contexts/AuthContext";

const DEVICE_WIDTH = 1280;
const DEVICE_HEIGHT = 800;

const DeviceInfoOverlay = () => {
    const { isLoggedIn, selectedStore, selectedChannel, selectedDevice, virtualNumber } = useAuth();
    const [visible, setVisible] = useState(false);
    const [pos, setPos] = useState({ x: 8, y: 8 });
    const dragging = useRef(false);
    const didDrag = useRef(false);
    const offset = useRef({ x: 0, y: 0 });

    const onMouseDown = useCallback((e) => {
        dragging.current = true;
        didDrag.current = false;
        offset.current = { x: e.clientX - pos.x, y: e.clientY - pos.y };
        e.preventDefault();
    }, [pos]);

    const onMouseMove = useCallback((e) => {
        if (!dragging.current) return;
        didDrag.current = true;
        setPos({ x: e.clientX - offset.current.x, y: e.clientY - offset.current.y });
    }, []);

    const onMouseUp = useCallback(() => {
        dragging.current = false;
    }, []);

    const onClick = useCallback(() => {
        if (!didDrag.current) setVisible(v => !v);
    }, []);

    if (!isLoggedIn) return null;

    return (
        <div
            onMouseDown={onMouseDown}
            onMouseMove={onMouseMove}
            onMouseUp={onMouseUp}
            onMouseLeave={onMouseUp}
            onClick={onClick}
            style={visible ? {
                position: 'absolute',
                top: pos.y,
                left: pos.x,
                zIndex: 9999,
                background: 'rgba(0,0,0,0.55)',
                color: '#FFFFFF',
                fontFamily: 'monospace',
                fontSize: '11px',
                lineHeight: '1.6',
                padding: '6px 10px',
                borderRadius: '6px',
                cursor: 'grab',
                userSelect: 'none',
            } : {
                position: 'absolute',
                top: pos.y,
                left: pos.x,
                zIndex: 9999,
                width: 8,
                height: 8,
                borderRadius: '50%',
                background: 'rgba(0,0,0,0.25)',
                cursor: 'grab',
                userSelect: 'none',
            }}
        >
            {visible && (
                <>
                    <div>store: {selectedStore?.name ?? '—'} ({selectedStore?.uuid ?? '—'})</div>
                    <div>channel: {selectedChannel?.name ?? '—'} ({selectedChannel?.uuid ?? '—'})</div>
                    <div>device: {selectedDevice?.serial_key ?? '—'}{selectedDevice?.alias ? ` (${selectedDevice.alias})` : ''}</div>
                    <div>virtual: {virtualNumber ?? '—'}</div>
                </>
            )}
        </div>
    );
};

const DeviceScreenLayout = ({children}) => {
    const { width, height } = useWindowSize();
    const isLarge = width > DEVICE_WIDTH && height > DEVICE_HEIGHT;

    return (
        <div
            style={{
                width: '100dvw',
                height: '100dvh',
                minHeight: '100dvh',
                background: isLarge ? '#F3F4F6' : '#FFFFFF',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <div
                style={{
                    width: isLarge ? `${DEVICE_WIDTH}px` : '100%',
                    height: isLarge ? `${DEVICE_HEIGHT}px` : '100%',
                    background: '#FFFFFF',
                    boxShadow: isLarge ? 'rgba(149, 157, 165, 0.2) 0px 8px 24px' : 'none',
                    position: 'relative',
                    overflow: 'hidden',
                }}
            >
                <DeviceInfoOverlay />
                {children}

            </div>

        </div>
    )
}

export default DeviceScreenLayout
